import React from "react";
import Helmet from "react-helmet";
import Resume from "../settings/resume.json";
import Settings from "../settings/settings.json";

// Global/default meta for the whole site. These are all react-helmet managed
// tags, so any page (e.g. Lifecoach) can override them by rendering its own
// <Helmet> deeper in the tree — the deeper declaration wins. Keep the static
// public/index.html <head> free of these same tags: helmet does NOT dedupe
// against non-helmet tags, it just appends them, which produces duplicates.
const OG_IMAGE = `${Resume.basics.url}/social-image.png`;
const OG_TITLE = `${Resume.basics.name} | Tech guy`;

export const HelmetMeta = () => {
    return (
        <Helmet>
            <meta name="theme-color" content={Settings.colors.primary} />
            <title>{Resume.basics.name} | {Resume.basics.label}</title>
            <meta name="author" content={Resume.basics.name} />
            <meta name="description" content={Resume.basics.description} />
            <meta name="keywords" content={Resume.basics.keywords} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="lucianlazar.io" />
            <meta property="og:title" content={OG_TITLE} />
            <meta property="og:description" content={Resume.basics.description} />
            <meta property="og:url" content={Resume.basics.url} />
            <meta property="og:image" content={OG_IMAGE} />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="600" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={OG_TITLE} />
            <meta name="twitter:description" content={Resume.basics.description} />
            <meta name="twitter:image" content={OG_IMAGE} />
        </Helmet>
    );
};
